import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/searchPage/actionTypes';

import { setDialogMakes } from './utils';

export default function* listenSetDialogMakes() {
  yield takeEvery(actionTypes.SET_DIALOG_MAKES, setDialogMakes);
}
